// extracted by mini-css-extract-plugin
export var link = "breadcrumb-link-module--link--HTEur";
export var notLink = "breadcrumb-link-module--not-link--SAeTH";